import { useHistory } from "react-router-dom";
import { JoinSpacesButtonView } from "./JoinSpacesButtonView";

export interface JoinSpacesButtonProps {
  spaceGroupSlug: string;
}

export const JoinSpacesButton = ({ spaceGroupSlug }: JoinSpacesButtonProps) => {
  const history = useHistory();

  const goToSpaceGroup = () => {
    history.push(`/s/${spaceGroupSlug}`);
  };

  return <JoinSpacesButtonView onClick={goToSpaceGroup} />;
};
